import { Injectable } from '@angular/core'
import { AccountService } from '../../services/account.service'
import { TypeOfUserEnum } from '@core/enums'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class AdminGuardService {
  constructor(
    private _accountService: AccountService,
    private _router: Router,
  ) {}

  isAdmin(): boolean {
    if (this._accountService.currentRoleId === TypeOfUserEnum.ADMIN) {
      return true
    }

    this._router.navigate(['/login'])
    return false
  }
}
